import React from 'react';
import MonthlyTurnoverCard from '../Common/MonthlyTurnover';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_TURNOVER);

const MonthlyTurnoverBCM = (props) => {
  return (
    <MonthlyTurnoverCard
      industryType='Bcm'
      questionId={ProfilerQuestionID.BCM_TURNOVER}
      {...props}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      type='select'
    />
  );
};

export default MonthlyTurnoverBCM;
